module.exports = __webpack_public_path__ + "static/media/ImgNovedades220915_2.4a397c0b.jpg";